import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import {
  CrossPlatformAbbreviations,
  IProvinces,
  PermissionsOfAdmin,
  ServiceTypes,
} from '@pharmaplan/common';
import { dropdownMapper } from '@pharmaplan/common/helpers/utils';
import {
  Constants,
  telephoneInputMask,
  TextFieldVariants,
} from '../../../../helpers/Constants';
import strings from '../../../../localization';
import genericClasses from '../../../../theme/GenericClasses';
import styles from './style';

const salesForceKey = 'salesForce';
const crossPlatformKey = 'crossPlatform';

export const adminEditFormConfig = (
  provinces: IProvinces[],
  disablePreferences: boolean,
  can:(permission:PermissionsOfAdmin) => boolean,
) => {
  const isSelfService = ServiceHandler.getService() === ServiceTypes.self;
  const canEditCrossPlatformSettings = can(PermissionsOfAdmin.CrossPlatformSettings);

  const common = [
    {
      label: strings.noOfDaysToRatePharmacist,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'ratePharmacistDays',
      xs: 6,
    },
    isSelfService && {
      label: strings.noOfDaysToRatePharmacy,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'ratePharmacyDays',
      xs: 6,
    },
    {
      label: strings.minHoursWorkshift,
      type: Constants.formInputType.text,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      name: 'minHourWorkshift',
      xs: 6,
    },
  ];

  // const hourlyRate = [
  //   {
  //     label: strings.formatString(strings.defaultHourlyRate, strings.pharmacy),
  //     type: Constants.formInputType.text,
  //     name: 'pharmacyRate',
  //     xs: 4,
  //     suffix: '$',
  //     maxLength: 6,
  //     customTextFieldStyle: genericClasses.customFilledInput,
  //     variant: TextFieldVariants.filled,
  //   },
  //   {
  //     label: strings.formatString(
  //       strings.userWeekdayRate,
  //       strings.pharmacy,
  //     ) as string,
  //     customTextFieldStyle: genericClasses.customFilledInput,
  //     variant: TextFieldVariants.filled,
  //     type: Constants.formInputType.text,
  //     suffix: '$',
  //     maxLength: 6,
  //     name: 'pharmacyWeekDayHourlyRate',
  //     xs: 4,
  //   },
  //   {
  //     label: strings.formatString(
  //       strings.userWeekendRate,
  //       strings.pharmacy,
  //     ) as string,
  //     customTextFieldStyle: genericClasses.customFilledInput,
  //     variant: TextFieldVariants.filled,
  //     type: Constants.formInputType.text,
  //     suffix: '$',
  //     maxLength: 6,
  //     name: 'pharmacyWeekendHourlyRate',
  //     xs: 4,
  //   },
  // ];

  const rates = [
    {
      label: strings.pharmacist,
      type: Constants.formInputType.label,
      style: { paddingBottom: 0, padding: 0, marginBottom: '6px' },
      labelClass: {
        color: '#8690AA',
        fontSize: 15,
      },
    },
    {
      label: strings.formatString(strings.singleDayFormat, strings.pharmacist),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'pharmacistRate',
      xs: 4,
      suffix: '$',
      maxLength: 6,
    },
    {
      label: strings.formatString(strings.multiWeekdayFormat, strings.pharmacist),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'pharmacistWeekDayHourlyRate',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    {
      label: strings.formatString(strings.multiWeekendFormat, strings.pharmacist),
      type: Constants.formInputType.text,
      name: 'pharmacistWeekendHourlyRate',
      xs: 4,
      suffix: '$',
      maxLength: 6,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
    },
    {
      label: strings.formatString(strings.singleDayFormat, strings.pharmacy),
      type: Constants.formInputType.text,
      name: 'pharmacyRate',
      xs: 4,
      suffix: '$',
      maxLength: 6,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
    },
    {
      label: strings.formatString(strings.multiWeekdayFormat, strings.pharmacy),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'pharmacyWeekDayHourlyRate',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    {
      label: strings.formatString(strings.multiWeekendFormat, strings.pharmacy),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'pharmacyWeekendHourlyRate',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    {
      label: strings.technician,
      type: Constants.formInputType.label,
      style: { paddingBottom: 0, padding: 0, marginBottom: '6px' },
      labelClass: {
        fontSize: 15,
        color: '#8690AA',
      },
    },
    {
      label: strings.formatString(strings.singleDayFormat, strings.technician),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'technicianRate',
      xs: 4,
      suffix: '$',
      maxLength: 6,
    },
    {
      label: strings.formatString(strings.multiWeekdayFormat, strings.technician),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'technicianWeekDayHourlyRate',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    {
      label: strings.formatString(strings.multiWeekendFormat, strings.technician),
      type: Constants.formInputType.text,
      name: 'technicianWeekendHourlyRate',
      xs: 4,
      suffix: '$',
      maxLength: 6,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
    },
    {
      label: strings.formatString(strings.singleDayFormat, strings.pharmacy),
      type: Constants.formInputType.text,
      name: 'pharmacyRateForTech',
      xs: 4,
      suffix: '$',
      maxLength: 6,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
    },
    {
      label: strings.formatString(strings.multiWeekdayFormat, strings.pharmacy),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'pharmacyWeekDayHourlyRateForTech',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    {
      label: strings.formatString(strings.multiWeekendFormat, strings.pharmacy),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'pharmacyWeekendHourlyRateForTech',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    isSelfService && {
      label: strings.formatString(strings.singleDayFormat, strings.student),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'studentRate',
      xs: 4,
      suffix: '$',
      maxLength: 6,
    },
    isSelfService && {
      label: strings.formatString(strings.multiWeekdayFormat, strings.student),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'studentWeekDayHourlyRate',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    isSelfService && {
      label: strings.formatString(strings.multiWeekendFormat, strings.student),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'studentWeekendHourlyRate',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    isSelfService && {
      label: strings.formatString(strings.singleDayFormat, strings.pharmacy),
      type: Constants.formInputType.text,
      name: 'pharmacyRateForStudent',
      xs: 4,
      suffix: '$',
      maxLength: 6,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
    },
    isSelfService && {
      label: strings.formatString(strings.multiWeekdayFormat, strings.pharmacy),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'pharmacyWeekDayHourlyRateForStudent',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
    isSelfService && {
      label: strings.formatString(strings.multiWeekendFormat, strings.pharmacy),
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      type: Constants.formInputType.text,
      name: 'pharmacyWeekendHourlyRateForStudent',
      suffix: '$',
      maxLength: 6,
      xs: 4,
    },
  ];

  const title = isSelfService ? strings.pharmagap : strings.pharmaPlan;

  const selfPreFormConfig = [
    {
      label: strings.formatString(strings.feesFormat, strings.unlimited),
      type: Constants.formInputType.text,
      name: 'unlimitedPackagePrice',
      xs: 6,
      suffix: '$',
      maxLength: 6,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
    },
    {
      label: strings.formatString(strings.feesFormat, strings.standard),
      type: Constants.formInputType.text,
      name: 'basicPackagePrice',
      xs: 6,
      suffix: '$',
      maxLength: 6,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
    },
  ];

  const selfPostFormConfig = [
    {
      label: strings.requestPendingPeriod,
      type: Constants.formInputType.text,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      name: 'bookingStateExpiration',
      xs: 6,
      suffix: strings.hoursAbbreviation,
    },

    {
      label: strings.pharmacyReminder,
      type: Constants.formInputType.text,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      name: 'pharmacyReminderBefore',
      xs: 6,
      suffix: strings.hoursAbbreviation,
    },
    {
      label: strings.tps,
      type: Constants.formInputType.text,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      name: 'tpsPercentage',
      xs: 6,
      suffix: '%',
    },
    {
      label: strings.tvq,
      type: Constants.formInputType.text,
      customTextFieldStyle: genericClasses.customFilledInput,
      variant: TextFieldVariants.filled,
      name: 'tvqPercentage',
      xs: 6,
      suffix: '%',
    },
    {
      label: strings.taxOnTax,
      type: Constants.formInputType.checkbox,
      name: 'taxOnTax',
      id: 'taxOnTax',
      xs: 6,
      customClass: styles.checkbox,
      labelClass: styles.checkboxText,
    },
  ];

  const formConfig = () =>
    (isSelfService
      ? [...selfPreFormConfig, ...common, ...selfPostFormConfig]
      : [...common]);

  const formRates = () =>
    (isSelfService ? rates : [...rates]);

  const pharmagapAccountSettings = {
    key: -1,
    title: strings.accountSettings,
    form: () =>
      [
        {
          label: strings.companyName,
          type: Constants.formInputType.text,
          customTextFieldStyle: genericClasses.customFilledInput,
          variant: TextFieldVariants.filled,
          name: 'companyName',
          id: 'companyName',
          xs: 6,
        },
        {
          label: strings.address,
          type: Constants.formInputType.text,
          customTextFieldStyle: genericClasses.customFilledInput,
          variant: TextFieldVariants.filled,
          name: 'address',
          id: 'address',
          xs: 6,
        },
        {
          label: strings.city,
          type: Constants.formInputType.text,
          customTextFieldStyle: genericClasses.customFilledInput,
          variant: TextFieldVariants.filled,
          name: 'city',
          id: 'city',
          xs: 6,
        },
        {
          label: strings.province,
          type: Constants.formInputType.dropdown,
          menuItems: dropdownMapper(provinces ?? [], 'key', 'name'),
          customTextFieldStyle: genericClasses.customFilledInput,
          variant: TextFieldVariants.filled,
          name: 'province',
          id: 'province',
          xs: 6,
        },
        {
          label: strings.phoneNumber,
          type: Constants.formInputType.masked,
          customTextFieldStyle: genericClasses.customFilledInput,
          variant: TextFieldVariants.filled,
          name: 'phoneNumber',
          id: 'phoneNumber',
          mask: telephoneInputMask,
          xs: 6,
        },
        isSelfService && {
          label: strings.businessTPS,
          type: Constants.formInputType.text,
          customTextFieldStyle: genericClasses.customFilledInput,
          variant: TextFieldVariants.filled,
          maxLength: 30,
          name: 'tpsNumber',
          id: 'tpsNumber',
          xs: 6,
        },
        isSelfService && {
          label: strings.businessTVQ,
          type: Constants.formInputType.text,
          customTextFieldStyle: genericClasses.customFilledInput,
          variant: TextFieldVariants.filled,
          name: 'tvqNumber',
          maxLength: 30,
          id: 'tvqNumber',
          xs: 6,
        },
      ],
  };

  let arr = [
    pharmagapAccountSettings,
    {
      key: 0,
      title: strings.formatString(strings.customSettings, title),
      form: formConfig,
    },
    {
      key: 0.5,
      title: strings.hourlyRateSettings,
      form: formRates,
    },
    {
      key: 1,
      title: strings.formatString(
        strings.customSettings,
        strings.customerServiceRepresentative,
      ),
      form: () =>
        [
          {
            label: strings.representativeName,
            type: Constants.formInputType.text,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
            name: 'representativeName',
            xs: 6,
          },
          {
            label: strings.representativeEmail,
            type: Constants.formInputType.text,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
            name: 'representativeEmail',
            xs: 6,
          },
          {
            label: strings.representativePhone,
            type: Constants.formInputType.text,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
            name: 'representativePhone',
            xs: 6,
          },
          {
            label: strings.phoneExt,
            type: Constants.formInputType.text,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
            name: 'representativePhoneExt',
            xs: 6,
          },
        ],
    },
    {
      key: salesForceKey,
      title: strings.formatString(strings.customSettings, strings.salesforce),
      form: () =>
        [
          {
            label: strings.salesForceUsername,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
            type: Constants.formInputType.text,
            name: 'salesForceUserName',
            xs: 6,
          },
          {
            label: strings.salesForcePWD,
            type: Constants.formInputType.text,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
            name: 'salesForcePassword',
            xs: 6,
          },
          {
            label: strings.salesForceSecurityToken,
            type: Constants.formInputType.text,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
            name: 'salesForceSecurityToken',
            xs: 6,
          },
          {
            label: strings.urlOfSalesForce,
            type: Constants.formInputType.text,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
            name: 'salesForceURL',
            xs: 6,
          },
          {
            label: strings.integrationSalesForce,
            type: Constants.formInputType.checkbox,
            name: 'salesForceActive',
            id: 'salesForceActive',
            xs: 6,
            customClass: styles.checkbox,
            labelClass: styles.checkboxText,
          },
        ],
    },
    {
      key: 3.5,
      title: strings.bookingInvitationEmailsSettings,
      form: () =>
        [
          {
            label: strings.professionalCapacity,
            type: Constants.formInputType.checkbox,
            name: 'professionalCapacity',
            id: 'professionalCapacity',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            disabled: disablePreferences,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.softwareKnowledge,
            type: Constants.formInputType.checkbox,
            name: 'softwareKnowledge',
            id: 'softwareKnowledge',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            disabled: disablePreferences,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.preferredShiftDuration,
            type: Constants.formInputType.checkbox,
            name: 'preferredShiftHours',
            id: 'preferredShiftHours',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            disabled: disablePreferences,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.remoteRegions,
            type: Constants.formInputType.checkbox,
            name: 'remoteRegions',
            id: 'remoteRegions',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            disabled: disablePreferences,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.availability,
            type: Constants.formInputType.checkbox,
            name: 'availability',
            id: 'availability',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            disabled: disablePreferences,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.maxTravelDistance,
            type: Constants.formInputType.checkbox,
            name: 'maxTravelDistance',
            id: 'maxTravelDistance',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            disabled: disablePreferences,
            labelClass: styles.checkboxText,
          },

          isSelfService && {
            label: strings.formatString(
              strings.showCrossShiftFormat,
              CrossPlatformAbbreviations.full,
              CrossPlatformAbbreviations.self,
            ),
            type: Constants.formInputType.checkbox,
            name: 'includePPShifts',
            id: 'includePPShifts',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            disabled: disablePreferences,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.sendBookingInvitationEmails,
            type: Constants.formInputType.checkbox,
            name: 'sendBookingInvitationReminder',
            id: 'sendBookingInvitationReminder',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.bookingInvitationFrequencyDays,
            type: Constants.formInputType.text,
            name: 'repeatAfterDays',
            id: 'repeatAfterDays',
            xs: 6,
            infoText: strings.doNoModifyThisSetting,
            customTextFieldStyle: genericClasses.customFilledInput,
            variant: TextFieldVariants.filled,
          },
        ],
    },
    {
      key: 4,
      title: strings.formatString(strings.customSettings, strings.more),
      form: () =>
        [
          {
            label: strings.sendAllEmailsBCC,
            type: Constants.formInputType.checkbox,
            name: 'envoiceBCCAdmin',
            id: 'envoiceBCCAdmin',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.showAllBookingDetails,
            type: Constants.formInputType.checkbox,
            name: 'showBookingDetails',
            id: 'showBookingDetails',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.enableChat,
            type: Constants.formInputType.checkbox,
            name: 'enableChat',
            id: 'enableChat',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.enableAIOnboarding,
            type: Constants.formInputType.checkbox,
            name: 'enableAIOnboarding',
            id: 'enableAIOnboarding',
            xs: 6,
            customClass: { ...styles.moreSettingsCheckbox, marginBottom: 2 },
            labelClass: styles.checkboxText,
          },
        ],
    },
    {
      key: crossPlatformKey,
      title: strings.crossPlatformSettings,
      form: () =>
        [
          {
            label: strings.postTechnicianShiftsOnPG,
            type: Constants.formInputType.checkbox,
            name: 'syncTechnicianShifts',
            id: 'syncTechnicianShifts',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            labelClass: styles.checkboxText,
          },
          {
            label: strings.postPharmacistShiftsOnPG,
            type: Constants.formInputType.checkbox,
            name: 'syncPharmacistShifts',
            id: 'syncPharmacistShifts',
            xs: 6,
            customClass: styles.moreSettingsCheckbox,
            labelClass: styles.checkboxText,
          },
        ],
    },
  ];

  if (isSelfService) {
    arr = arr.filter((item) =>
      item.key !== salesForceKey);
  }

  if (!canEditCrossPlatformSettings || isSelfService) {
    arr = arr.filter((item) =>
      item.key !== crossPlatformKey);
  }

  return arr;
};
